import { ValidationInterface } from '../../validation.interface';
import {
  ProductFeeType,
  Product,
  ProductPropName
} from '../../../../models/project/plant-specifications/product.model';
import { ProjectValidationUnit } from '../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../unit-value.validation';
import {PlantSpecificationsPropName} from '../../../../models/project/plant-specifications/plant-specifications.model';

export class FinancialProductValidation implements ValidationInterface {
  private readonly product: Product;

  constructor(product: Product) {
    if (!product) throw Error('invalid product provided for financial validation');
    this.product = new Product(product);
  }

  getValidation(): ProjectValidationUnit {
    if (!this.product) throw Error('unable to validate product financial');
    const validationUnit = new ProjectValidationUnit();
    if (this.product.priceIsVariable) {
      this.validateVariablePrice(validationUnit);
    } else {
      this.validateFixedPrice(validationUnit);
    }
    return validationUnit;
  }

  validateVariablePrice(validationUnit: ProjectValidationUnit) {
    validationUnit.validate(this.product.rangeOf, ProductPropName.amountRangeOf, ProductErrorMessage.AMOUNT_RANGE_OF);
    if (this.product.priceStructures.length > 0) {
      for (let i = 0; i < this.product.priceStructures.length; i++) {
        validationUnit.addArrayToModuleResults(
          this.product.priceStructures[i].getValidation(),
          PlantSpecificationsPropName.priceStructures,
          i,
          this.product.priceStructures[i].name
        );
      }
    } else {
      validationUnit.setInvalid(PlantSpecificationsPropName.priceStructures, [ProductErrorMessage.MISSING_PRICE_STRUCTURE]);
    }
  }

  validateFixedPrice(validationUnit: ProjectValidationUnit) {
    if (this.product.isSellableDigestate()) {
      if (this.product.priceType) {
        validationUnit.setValid(ProductPropName.priceType);
      } else {
        validationUnit.setInvalid(ProductPropName.priceType, [ProductErrorMessage.PRICE_TYPE_NOT_SELECTED]);
      }
      if (this.product && this.product.priceType === ProductFeeType.FREE) {
        return;
      }
    }
    validationUnit.addModuleResults(
      new UnitValueValidation(this.product.price).getValidation(),
      ProductPropName.price
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.product.quantity).getValidation(),
      ProductPropName.quantity
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.product.cpi).getValidation(),
      ProductPropName.cpi
    );
  }

  isValid(): boolean {
    return this.getValidation().isValid;
  }
}

enum ProductErrorMessage {
  PRICE_TYPE_NOT_SELECTED = 'VALIDATION.MISSING_PRICE_TYPE',
  MISSING_PRICE_STRUCTURE = 'VALIDATION.MISSING_PRICE_STRUCTURE',
  AMOUNT_RANGE_OF = 'VALIDATION.AMOUNT_RANGE_OF'
}
